// Reactor
import { createActions } from 'reactor/core/redux'

const ACTIONS = {
  CUSTOM: {
    RCR_START_UPLOAD: {hasProgress: true},
    RCR_RETRY_UPLOAD: {hasProgress: true},
    RCR_UPLOAD: {},
  },
  LOCAL: {
    RCR_UPLOAD_PROGRESS: {},
    RCR_CLEAR_UPLOAD_DATA: {},
    RCR_REMOVE_FAILED_UPLOAD: {}
  }
}

export default createActions(ACTIONS, 'upload')
